<template>
  <div class="container">
    <div>
      <b-nav align="right">
        <!-- ADD PRODUCT -->
        <b-button v-b-modal.add-variant class="mr-3" variant="primary"
          >Add Variants
        </b-button>
        <b-modal
          id="add-variant"
          title="Add Supported Variants"
          hide-footer
          size="lg"
          @close="clearSelections()"
          @cancel="clearSelections()"
          @hide="clearSelections()"
        >
          <!-- SELECT PARENTS -->
          <div class="mb-2">
            <b-form-input
              v-model="search"
              placeholder="Search Products"
            ></b-form-input>
          </div>
          <div v-if="!parentsSelected">
            <div class="d-flex justify-content-between mb-2">
              <h3>1. Select Variants</h3>
              <b-button @click="addParents()">
                Next
                <b-icon icon="chevron-right" aria-hidden="true"></b-icon>
              </b-button>
            </div>
            <div class="d-flex justify-content-between mb-5">
              <ul>
                <li v-for="vId of selectedParentIds" :key="vId">
                  {{ lookupDisplayName(vId) }}
                </li>
              </ul>
            </div>
            <div
              v-for="(p, index) in products"
              :key="p.id"
              class="product-group mb-2"
            >
              <div class="d-flex justify-content-between mb-3">
                <h6 class="mb-0">{{ p.productType }} - {{ p.title }}</h6>
                <b-button
                  v-if="!p.variants"
                  style="max-width: 130px"
                  block
                  variant="link"
                  @click="getVariants(p.id)"
                >
                  Show Variants
                </b-button>
              </div>
              <b-form-group>
                <b-form-checkbox-group
                  :id="'parent-select-' + index"
                  v-model="selectedParentIds"
                  stacked
                  value-field="id"
                  text-field="parentTitle"
                  :options="p.variants"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>

          <!-- SELECT CHILDREN -->
          <div v-else>
            <div class="d-flex justify-content-between mb-2">
              <h3>2. Select Dependencies</h3>
              <div>
                <b-button
                  variant="primary"
                  class="mr-2"
                  @click="createPicklistVariants()"
                >
                  Finish
                </b-button>
                <b-button @click="clearSelections()">Back</b-button>
              </div>
            </div>
            <div class="d-flex justify-content-between mb-5">
              <ul>
                <li v-for="vId of selectedChildrenIds" :key="vId">
                  {{ lookupDisplayName(vId) }}
                </li>
              </ul>
            </div>
            <div
              v-for="(p, index) in products"
              :key="p.id"
              class="mb-2 product-group"
            >
              <div class="d-flex justify-content-between mb-1">
                <h6 class="mb-0">{{ p.title }}</h6>
                <b-button
                  v-if="!p.variants"
                  style="max-width: 130px"
                  block
                  @click="getVariants(p.id)"
                  >Show Variants
                </b-button>
              </div>
              <b-form-group>
                <b-form-checkbox-group
                  :id="'children-select-' + index"
                  v-model="selectedChildrenIds"
                  stacked
                  value-field="id"
                  text-field="title"
                  :options="p.variants"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </b-modal>

        <!-- GO BACK HOME -->
        <b-button @click="$router.push('/')" class="primary">Done</b-button>
      </b-nav>
    </div>
    <div class="row">
      <div class="col">
        <!-- VARIANTS TABLE GROUPED BY PRODUCT -->
        <b-table
          :items="picklistVariants"
          :fields="picklistVariantsGroupedFields"
          striped
          borderless
          small
        >
          <template #cell(show_details)="row">
            <b-button size="sm" @click="row.toggleDetails" class="mr-2">
              {{ row.detailsShowing ? "Hide" : "Show" }} Details
            </b-button>
          </template>

          <template #row-details="row">
            <b-card>
              <b-button class="mb-3" size="sm" @click="row.toggleDetails"
                >Hide Details</b-button
              >
              <!-- VARIANTS TABLE -->
              <b-table
                small
                striped
                borderless
                :items="row.item.variants"
                :fields="picklistVariantsFields"
              >
                <template #cell(actions)="data">
                  <!-- EDIT PRODUCT -->
                  <b-button class="mr-3" @click="editVariant(data.item)"
                    >Edit
                    <b-icon icon="pencil-square" aria-hidden="true"></b-icon
                  ></b-button>

                  <!-- REMOVE PRODUCT -->
                  <b-button
                    v-b-modal="data.item.id + 'remove'"
                    class="btn-danger"
                    ><b-icon icon="trash-fill" aria-hidden="true"></b-icon
                  ></b-button>
                  <b-modal
                    :id="data.item.id + 'remove'"
                    @ok="removeVariant(data.item.id)"
                    title="Remove Product"
                  >
                    <p class="my-4">
                      Are you sure you want to remove {{ data.item.title }}
                    </p>
                  </b-modal>
                </template>
              </b-table>
            </b-card>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Settings",
  data() {
    return {
      addVariantFields: ["displayName", { key: "actions", label: "" }],
      picklistVariantsFields: ["displayName", { key: "actions", label: "" }],
      picklistVariantsGroupedFields: ["name", "type", "show_details"],
      selectedChildrenIds: [],
      selectedParentIds: [],
      parentsSelected: false,
      search: "",
    };
  },
  methods: {
    async addParents(id) {
      this.parentsSelected = true;
    },
    clearSelections() {
      this.$store.dispatch("clearSelectedVariant");
      this.selectedChildrenIds = [];
      this.selectedParentIds = [];
      this.parentsSelected = false;
    },
    async createPicklistVariants() {
      let children = this.selectedChildrenIds.map((id) => {
        return this.variants.find((v) => v.id === id);
      });
      let picklistVariants = this.selectedParentIds.map((id) => {
        let parent = this.variants.find((v) => v.id === id);
        return {
          ...parent,
          children,
        };
      });
      await this.$store.dispatch("updatePicklistVariants", picklistVariants);
      this.$bvModal.hide("add-variant");
    },
    async getVariants(id) {
      await this.$store.dispatch("getVariants", { id });
    },
    async editVariant(variant) {
      await this.getVariants(variant.product.id);
      this.selectedParentIds = [variant.id];
      this.parentsSelected = true;
      if (variant.children) {
        this.selectedChildrenIds = [...variant.children.map((c) => c.id)];
        for (var c of variant.children) {
          await this.getVariants(c.product.id);
        }
      }

      this.$bvModal.show("add-variant");
    },
    removeVariant(id) {
      this.$store.dispatch("deletePicklistVariants", [id]);
    },
    lookupDisplayName(id) {
      let variant = this.variants.find((v) => v.id === id);
      return variant?.displayName;
    },
    variantAdded(id) {
      console.log("variantAdded", id);
      for (var p of this.picklistVariants) {
        let variant = p.variants.find((v) => v.id === id);
        if (variant) console.log("variant found", variant.displayName);
        return variant !== undefined ? " - added" : "";
      }
    },
  },
  computed: {
    products() {
      return this.$store.state.products
        .map((p) => {
          p.value = p.id;
          p.text = p.title;
          p.disabled = false;
          if (p.variants) {
            p.variants = p.variants.map((v) => {
              v.parentTitle = `${v.title}${this.variantAdded(v.id)}`;
              v.type = v.product.type;
              return v;
            });
          }
          return p;
        })
        .filter((p) => {
          let searchTitle = p.title
            .toLowerCase()
            .includes(this.search.toLowerCase());
          let searchType = p.productType
            .toLowerCase()
            .includes(this.search.toLowerCase());
          let searchTags = p.tags.includes(this.search.toLowerCase());
          if (this.search.length > 1) {
            return searchTitle || searchType || searchTags;
          } else {
            return true;
          }
        });
    },
    variants() {
      return this.$store.state.products
        .map((p) => p.variants)
        .filter((v) => v !== undefined)
        .flat()
        .map((v) => {
          let fulfillmentColor = v?.metafields?.edges.find((e) => {
            return e.node.namespace === "fulfillment";
          });
          console.log("fulfillmentColor", fulfillmentColor);
          if (fulfillmentColor) {
            v.fulfillmentColor = fulfillmentColor.node.value;
            delete v.metafields;
            return v;
          }
          return v;
        });
    },
    selectedVariant() {
      if (this.$store.state?.selectedVariant?.children) {
        this.selectedChildrenIds = [
          ...this.$store.state.selectedVariant.children,
        ];
      }
      return this.$store.state.selectedVariant;
    },
    picklistVariants() {
      const variants = this.$store.state.picklistVariants;
      const products = [];
      for (var v of variants) {
        console.log("variant", v);
        let product = products.find((p) => {
          return p.name === v.product.title && p.type === v.product.productType;
        });
        console.log("product", product);
        if (!product) {
          product = {
            name: v.product.title,
            variants: [v],
            type: v.product.productType,
          };
          products.push(product);
        }
        product.variants.push(v);
      }
      console.log("picllist variants", products);
      return products;
    },
  },
  async mounted() {
    await this.$store.dispatch("getPicklistVariants");
    await this.$store.dispatch("getProducts");
  },
};
</script>

<style lang="scss">
.product-group {
  border-bottom: 1px solid lightgray;
}
</style>